export function initAnchorNavigation(scope: Document | HTMLElement = document) {
  const anchorNavigation: HTMLElement|null = document.querySelector('.js-anchorNav');
  const anchorNavigationLinkWrapper: HTMLElement|null = document.querySelector('.js-anchorNavLinks');
  const anchorNavigationElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-anchorNavItem');
  const mobileActiveToggleElement: HTMLElement|null = document.querySelector('.js-anchorNavToggle');
  const activeClass = 'stickyMenu--active';

  if (anchorNavigation && anchorNavigationLinkWrapper) {
    anchorNavigationElements.forEach((navItem) => {
      const linkUrl = navItem.dataset.anchorLink;
      const linkText = navItem.dataset.anchorTitle;
      if (linkUrl && linkText) {
        const link = document.createElement('a');
        link.href = linkUrl;
        link.classList.add('stickyMenu__link');
        link.appendChild(document.createTextNode(linkText));

        link.addEventListener('click', () => {
          anchorNavigation.classList.remove(activeClass);
        });

        anchorNavigationLinkWrapper.appendChild(link);
      }
    });

    //close on mobile if clicked outside of flyout
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (window.innerWidth < 1024) {
        if (!target.closest('.js-anchorNavInner') && anchorNavigation.classList.contains(activeClass)) {
          anchorNavigation.classList.remove(activeClass);
        }
      }
    });
  }

  if (mobileActiveToggleElement) {
    mobileActiveToggleElement.addEventListener('click', () => {
      if (window.innerWidth < 1024) {
        anchorNavigation?.classList.toggle(activeClass);
      }
    });
  }
}
